<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:CautionMassege
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/06 | 富士通株式会社         | 新規作成
// 01.01.00 | 2024/03/29 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div :class="[classDiv != '' ? classDiv : '']">
		<div
			v-for="(item, index) in cautionMessagelist"
			:key="index"
		>
			<div
				v-if="item.messageType === 1"
				class="contents__caution--div div_row contents__caution--multiple"
				v-html="item.val"
			/>
			<div
				v-else
				class="div_row contents__caution--multiple"
				v-html="item.val"
			/>
		</div>
	</div>
</template>

<script>
import { co_post } from '@/common/ajaxUtility.js';
import { co_isEmpty } from '@/common/checkUtility.js'

import { API_CAUTION_ITEMS } from '@/const/route.js';

export default {
	inheritAttrs: false,
	props: {
		tyuibunItems: {type: Array, default: function() {
				return []
			}
		},	// 注意文リスト
		cdHanyo1: {type: String, default: ''},		// 汎用コード１
		cdHanyo2: {type: String, default: ''},		// 汎用コード２
		replaceItems: {type: Array, default: function() {
				return []
			}
		},	// 置換文字列リスト
		linkUrlItems: {type: Array, default: function() {
				return []
			}
		},	// リンクURLリスト
		visibilityFlg: {type: Boolean, default: true},	// リンクURL設定時、注意文表示不可フラグ（true:表示、false:非表示）
		classDiv: {type: String, default: ''},			// 注意文エリアのスタイル
	},
	data: function() {
		return {
			cautionMessagelist: []
		}
	},
	computed: {
		
	},
	watch: {
		tyuibunItems: async function () {

			this.cautionMessagelist = [];

			if (!co_isEmpty(this.tyuibunItems))	{
				// 受け取った注意文番号で注意文を生成
				this.createList(await this.getData());
			}
		},
		cdHanyo2: async function () {

			this.cautionMessagelist = [];

			if (!co_isEmpty(this.cdHanyo2))	{
				// 受け取った汎用コードで注意文を生成
				this.createList(await this.getData());
			}
		},
		linkUrlItems: async function () {
			
			this.cautionMessagelist = [];
			if (!co_isEmpty(this.linkUrlItems))	{
				// 受け取ったURLリンクで注意文を生成
				this.createList(await this.getData());
			}
		}
	},
	created: async function() {
		
		if (!co_isEmpty(this.tyuibunItems))	{
			// 親から受け取った注意文番号で注意文を生成
			this.createList( await this.getData() );
		} else if (!co_isEmpty(this.cdHanyo2)) {
			// 親から受け取ったjson文字列でリストを設定
			this.createList( await this.getData() );
		}
	},
	beforeUnmount: function() {

	},
	methods: {
		// 注意文マスタより注意文情報を取得
		getData: function() {

			let params = [];
			if (!co_isEmpty(this.tyuibunItems))	{
				params = {tyuibunList: this.tyuibunItems};
			} else if (!co_isEmpty(this.cdHanyo2)) {
				params = { cdHanyo1: this.cdHanyo1, cdHanyo2: this.cdHanyo2 };
			}
			// ajaxにてサーバーと通信
			return co_post( API_CAUTION_ITEMS, params );
		},
		// リスト作成
		createList: function( val ) {

			let cautionMessagelist = [];
			let templateCautionKome = '<div class="contents__caution--div_mark"><p class="contents__caution contents__caution--multiple @W">※</p></div><div><p class="contents__caution contents__caution--multiple @W">@1</p></div>';

			if ( val != null ) {
				for ( let i = 0; i < val.length; i++ ) {
					let sentence = '';			// メッセージ（一行文）
					let sentenceList = [];		// メッセージリスト
					let listCount = 0;			// <li>タグ生成数
					let listCountMax = 0;		// <li>タグ最大生成数
					let messageType = 0;		// メッセージ
					let message = '';			// 画面表示用メッセージ

					if ((!co_isEmpty(this.linkUrlItems) && !co_isEmpty(this.linkUrlItems[0])) || !co_isEmpty(val[i].lkUrl)) {
						// リンクURLリスト設定時 または 注意文マスタ．リンクURL設定時
						if (!this.visibilityFlg) {
							// リンクURL設定時、注意文表示不可
							continue;
						}
					}

					if (val[i].messageNaiyo.indexOf('%D') >= 0) {
						// 「※」付き注意文の場合
						sentence = val[i].messageNaiyo.replace('%DS※','');
						sentence = sentence.replace('%DE','');
						sentence = sentence.replace(new RegExp(/\r\n|\n/, 'g'), '<br/>');
						message = templateCautionKome.replace(new RegExp('[@]' + 1, 'g'), sentence);
						messageType = 1;

					} else if (val[i].messageNaiyo.indexOf('%L') >= 0) {
						// リスト表示注意文の場合
						messageType = 2;
						sentenceList = val[i].messageNaiyo.split(/\r\n|\n/);

						for ( let j = 0; j < sentenceList.length; j++ ) {
							if (sentenceList[j].indexOf('%L') >= 0) {
								// 表示リスト数設定
								listCountMax = listCountMax + 1;
							}
						}

						for ( let j = 0; j < sentenceList.length; j++ ) {
							sentence = '';
							if (sentenceList[j].indexOf('%L') >= 0) {
								if(listCount === 0){
									message = message + '<ul class="contents__caution--ul">'
								}
								sentence = sentenceList[j].replace('%LS','');
								sentence = sentence.replace('%LE','');
								message = message + '<li class="contents__caution--li contents__caution--multiple @W">' + sentence + '</li>';
								if(listCount === listCountMax){
									message = message + '</ul>'
								}
								listCount = listCount + 1;
							} else {
								message = message + '<label class="contents__caution contents__caution--multiple @W">' + sentenceList[j] + '</label>'
							}
						}
					} else {
						sentenceList = val[i].messageNaiyo.split(/\r\n|\n/);
						for ( let j = 0; j < sentenceList.length; j++ ) {
							message = message + '<label class="contents__caution contents__caution--multiple @W">' + sentenceList[j] + '</label><br/>'
						}
					}

					// URLリンク生成
					if (!co_isEmpty(this.linkUrlItems) && !co_isEmpty(this.linkUrlItems[0])) {
						// リンクURLリスト設定時
						for (let i = 0; i < this.linkUrlItems.length; i++) {
							let retlink = message.indexOf('%A'+ (i));
							if (retlink >= 0) {
								message = message.replace('%A'+ (i) + 'S', '<a href="' + this.linkUrlItems[i] + '" target="_blank" rel="noopener noreferrer" tabindex="-1">');
								message = message.replace('%A'+ (i) + 'E', '</a>');
							}
						}
					} else if (!co_isEmpty(val[i].lkUrl)) {
						// リンクURLリスト未設定時、注意文マスタよりリンクURLを設定
						let lkUrlList = val[i].lkUrl.split(/\r\n|\n/);
						for (let i = 0; i < lkUrlList.length; i++) {
							let retlink = message.indexOf('%A'+ (i));
							if (retlink >= 0) {
								message = message.replace('%A'+ (i) + 'S', '<a href="' + lkUrlList[i].split('：')[1] + '" target="_blank" rel="noopener noreferrer" tabindex="-1">');
								message = message.replace('%A'+ (i) + 'E', '</a>');
							}
						}
					} else {
						let retlink = message.indexOf('%A'+ (i));
						if (retlink >= 0) {
							message = message.replace('%A'+ (i) + 'S', '');
							message = message.replace('%A'+ (i) + 'E', '');
						}
					}

					// 文字色変更
					if (val[i].kbMessageColor === 2) {
						message = message.replace(/@W/g, 'contents__caution--font_warn');
					} else {
						message = message.replace(/@W/g, '');
					}

					// 太字変更
					message = message.replace(/%BS/g, '<b>');
					message = message.replace(/%BE/g, '</b>');

					// 注意文設定
					cautionMessagelist.push({key: i , val: this.replaceParam(message), messageType: messageType});
				}
				this.cautionMessagelist = cautionMessagelist;
			}
		},
		// メッセージ置換
		replaceParam: function( msg ) {
			// 置換文字列が未設定
			if (this.replaceItems == null || this.replaceItems.length == 0) {
				return msg;
			}

			// メッセージ置換
			for (let i = 0; i < this.replaceItems.length; i++) {
				msg = msg.replace(new RegExp('[%]' + (i+1), 'g'), this.replaceItems[i]);
			}

			return msg;
		}
	}
}
</script>

<style scoped>
</style>